import React from "react";
import VideoList from "./VideoList";
import youtube from "../apis/youtube";

class VideoOverview extends React.Component {

    state = {
        videos: []
    }

    async componentDidMount() {
        const response = await youtube.get('/search', {
            params: {
                q: "classic concert",
            }
        });
        this.setState({videos: response.data.items});
    }

    render() {
        return (
            <VideoList videos={this.state.videos}/>
        );
    }
}

export default VideoOverview;